import { DiffMatchPatch } from 'diff-match-patch-typescript';
import axios from 'axios';
/**
 * @param e : Event
 * @param pastedElement : HTMLDivElement
 *
 * テキストエリアにテキストをペーストする際に、元の装飾を削除し
 * テキストのみをペーストする
 * また、改行をdivタグに変換する
*/
export const pasteTextAndFormat = (e, pastedElement) => {
    e.preventDefault();
    let paste = e.clipboardData?.getData('text/plain') || '';
    const placeholder = pastedElement.querySelector('.placeholder');
    if (placeholder) {
        placeholder.remove();
    }
    paste = paste.replace(/\t/g, ' ').replace(/ /g, '\u00A0');
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        return;
    }
    const range = selection.getRangeAt(0);
    const textLines = paste.split(/\r?\n/);
    const fragment = document.createDocumentFragment();
    textLines.forEach((line, i) => {
        const span = document.createElement('span');
        span.textContent = line || '';
        fragment.appendChild(span);
        if (i !== textLines.length - 1) {
            const br = document.createElement('br');
            fragment.appendChild(br);
        }
    });
    // ペーストテキスト最後のノードを保持 ※ペースト後にカーソルを移動させるため
    const lastNode = fragment.lastChild;
    rangeInsertNode(range, fragment);
    // カーソルをペーストした内容の末尾へ移動
    if (lastNode) {
        const selection = window.getSelection();
        if (selection) {
            const newRange = document.createRange();
            newRange.setStartAfter(lastNode);
            newRange.collapse(false);
            selection.removeAllRanges();
            selection.addRange(newRange);
        }
    }
};
const rangeInsertNode = (range, node) => {
    const element = range.commonAncestorContainer;
    if (element.innerHTML === '<br>' || element.innerHTML === '<br/>') {
        element.innerHTML = '';
    }
    range.deleteContents();
    range.insertNode(node);
};
export const flattenDivs = (parent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(parent.innerHTML, 'text/html');
    function flattenNode(node) {
        let result = '';
        let temp = [];
        if (node.childNodes.length === 0) {
            result += '<br>';
        }
        else {
            node.childNodes.forEach(child => {
                if (child.nodeType === Node.ELEMENT_NODE && child.tagName.toLowerCase() === 'div') {
                    if (result != '')
                        temp.push(`<div>${result}</div>`);
                    result = '';
                    if (child.querySelectorAll('div').length > 0) {
                        const tt = flattenNode(child);
                        if (tt != '')
                            temp.push(tt);
                    }
                    else {
                        temp.push(child.outerHTML);
                    }
                }
                else if (child.nodeType === Node.TEXT_NODE) {
                    result += child.textContent;
                }
                else {
                    result += child.outerHTML;
                }
            });
        }
        if (result != '') {
            temp.push(`<div>${result}</div>`);
        }
        return temp.join('');
    }
    let flattenedHtml = '';
    const bodyElement = doc.querySelector('body');
    bodyElement?.childNodes.forEach(child => {
        flattenedHtml += flattenNode(child);
    });
    parent.innerHTML = flattenedHtml;
};
/**
 *
 * @param textArea
 * @param placeholderClass
 * @param placeholderData
 *
 * カスタムプレースホルダーの挿入とそれに伴う動作の管理を行っています。
 * ユーザーが要素をクリックした際にプレースホルダーを隠し、
 * フォーカスが外れた際に内容が空であれば再度プレースホルダーを表示します。
 */
export const manageCustomPlaceholders = (textArea, placeholderClass, placeholderData) => {
    // .p-topInput__inner
    const elements = document.querySelectorAll(`${textArea}`);
    Array.prototype.forEach.call(elements, function (el) {
        // placeholderの要素作成
        const placeholder = document.createElement('p');
        placeholder.className = `${placeholderClass}`;
        placeholder.innerHTML = el.getAttribute(`${placeholderData}`);
        el.querySelector('div').appendChild(placeholder);
        if (!el)
            return;
        // アクセス時点で値が入力されている場合、placeholderを消しておく
        if (el.textContent.trim() === el.getAttribute(`${placeholderData}`).replace(/<br>/g, '')) {
            placeholder.style.display = 'block';
        }
        else {
            placeholder.style.display = 'none';
        }
        // placeholderがクリックされたとき
        placeholder.addEventListener('click', function () {
            el.style.display = 'none';
            if (this.parentNode != null) {
            }
            el.parentNode.focus();
        });
        // エレメントがフォーカスされたとき
        el.addEventListener('focus', function () {
            const elem = el.querySelector(`.${placeholderClass}`);
            if (elem) {
                elem.style.display = 'none';
            }
        });
        // フォーカスが外れたとき
        el.addEventListener('blur', function () {
            if (el.innerText.trim() === '') {
                const elem = el.querySelector(`.${placeholderClass}`);
                if (elem) {
                    elem.style.display = 'block';
                }
            }
        });
    });
};
/**
 * @param inputArea
 * 入力エリアが空の場合、空のdivを挿入する
 * 最初の行を削除させないため
 */
export const resetTextAreaOnEmptyInput = (inputArea) => {
    //inpuAreaの子要素にdivがない場合、divを挿入する
    if (inputArea.querySelectorAll('div').length === 0) {
        inputArea.innerHTML = '<div></div>';
    }
};
/**
 * @param textArea
 * 校正実行時にdiv要素内の行内でテキストが空行の場合は<br>タグを挿入する
 * 入力テキストエリア内の改行を保持するため
*/
export const insertBrTextDivs = (textArea) => {
    const divElements = textArea.querySelectorAll('div');
    divElements.forEach((div) => {
        if (div.innerHTML.trim() === '') {
            div.innerHTML = '<br>';
        }
    });
};
/**
 * @param textArea
 * 校正実行時にdiv要素内のテキストが入力されている行内に <br> タグが含まれている場合は<br> タグを削除する
 * 校正実行後の意図しない改行を防ぐため
*/
export const removeBrInTextDivs = (textArea) => {
    const divElements = textArea.querySelectorAll('div');
    divElements.forEach((div) => {
        const divTextContent = div.innerHTML.trim();
        if (divTextContent.includes('<br>')) {
            div.innerHTML = divTextContent.replace(/<br>/g, '');
        }
    });
};
/**
 * @param readTextElementId
 * @param startSpeechButtonId
 * @param stopSeechButtonId
 *
 * テキストを読み上げる機能。
 * ※ChatGPT apiの読み上げ機能に置き換えたため、このメソッドは使用していない
*/
export const speechManager = (readTextElementId, startSpeechButtonId, stopSeechButtonId) => {
    const synth = window.speechSynthesis;
    const text = document.getElementById(readTextElementId);
    const startSpeechBtn = document.getElementById(startSpeechButtonId);
    const stopSpeechBtn = document.getElementById(stopSeechButtonId);
    if (text == null || startSpeechBtn == null || stopSpeechBtn == null)
        throw new Error('Element not found');
    startSpeechBtn.addEventListener('click', function () {
        const speechText = text.innerText.trim();
        console.log('speechText', speechText);
        if (speechText !== '') {
            const utterance = new SpeechSynthesisUtterance(speechText);
            utterance.onend = function () {
                startSpeechBtn.style.display = 'flex';
                stopSpeechBtn.style.display = 'none';
            };
            synth.speak(utterance);
            startSpeechBtn.style.display = 'none';
            stopSpeechBtn.style.display = 'flex';
        }
        else {
            alert('テキストを入力してください。');
        }
    });
    stopSpeechBtn.addEventListener('click', function () {
        synth.cancel();
        startSpeechBtn.style.display = 'flex';
        stopSpeechBtn.style.display = 'none';
    });
};
export async function* streamChatCompletion(url, body, stopSignal) {
    const completion = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        signal: stopSignal,
    });
    const reader = completion.body?.getReader();
    console.log(completion.headers);
    if (!reader || completion.status !== 200)
        throw new Error('Response error');
    const decoder = new TextDecoder();
    let done = false;
    while (!done) {
        if (stopSignal && stopSignal.aborted) {
            console.log("Stream manually stopped.");
            reader.cancel(); // ストリームをキャンセル
            break;
        }
        const { done: readDone, value } = await reader.read();
        if (readDone) {
            done = true;
            reader.releaseLock();
        }
        else {
            const token = decoder.decode(value, { stream: true });
            yield token;
        }
    }
}
export const customFetch = async (url, body, option = undefined) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        ...option
    });
    if (!response.ok)
        throw new Error(`Fetch error [${response.status}]: ${response.statusText}`);
    const jsonResponse = await response.json();
    return jsonResponse.data;
};
/**
 * @param modal : HTMLElement
 * @param range : DOMRect
 * モーダルの位置を調整する
 * モーダルの位置をクリックした要素の下に表示する
 */
export const manageModalPosition = (scrollable, modal, range, changePosition) => {
    if (!scrollable)
        throw new Error('スクロール可能な要素が見つかりません');
    if (!modal)
        throw new Error('モーダルが見つかりません');
    modal.style.position = 'absolute';
    // if(changePosition.top) modal.style.top = `${range.bottom + scrollable.scrollTop}px`;
    // if(changePosition.left) modal.style.left = `${range.left + window.scrollX}px`;
    // 表示するモーダルの高さ+選択範囲のscrollable内容がscrollableの一番下を超える場合、rangeの上に表示する
    // 初期位置を設定
    let top = range.bottom + scrollable.scrollTop;
    let left = range.left + window.scrollX;
    // モーダルのクローンを作成
    const modalClone = modal.cloneNode(true);
    // クローンをドキュメントに一時的に追加
    document.body.appendChild(modalClone);
    // クローンを一時的に表示状態にする
    modalClone.style.visibility = 'hidden';
    modalClone.style.display = 'block';
    // クローンの高さを取得
    const modalHeight = modalClone.offsetHeight;
    // maxHeigthを取得
    const modalMaxHeigth = modalClone.style.maxHeight;
    console.log('modalHeight', modalHeight);
    // クローンを削除
    document.body.removeChild(modalClone);
    // scrollableの一番下の位置を取得
    const scrollableBottom = scrollable.scrollHeight;
    if (top + modalHeight > scrollableBottom) {
        // モーダルがscrollableの一番下を超える場合、選択範囲の上に表示する
        top = range.top + scrollable.scrollTop - modalHeight - 70; //固定値ゆるしてください。。。
    }
    // ポジションを適用
    if (changePosition.top)
        modal.style.top = `${top}px`;
    if (changePosition.bottom)
        modal.style.bottom = `${scrollableBottom - top}px`;
    if (changePosition.left)
        modal.style.left = `${left}px`;
};
/**
 * @param modal : HTMLElement
 * @param range : DOMRect
 * モーダルの位置を調整する
 * モーダルの位置をクリックした要素の下に表示する
 */
export const manageAIModalPosition = (scrollable, modal, range) => {
    if (!scrollable)
        throw new Error('スクロール可能な要素が見つかりません');
    if (!modal)
        throw new Error('モーダルが見つかりません');
    //modal top bottomを削除
    modal.style.top = '';
    modal.style.bottom = '';
    modal.style.position = 'absolute';
    // 初期位置を設定
    let top = range.bottom + scrollable.scrollTop;
    // モーダルのクローンを作成
    const modalClone = modal.cloneNode(true);
    // クローンをドキュメントに一時的に追加
    document.body.appendChild(modalClone);
    // クローンを一時的に表示状態にする
    modalClone.style.visibility = 'hidden';
    modalClone.style.display = 'block';
    // CSSスタイルオブジェクトを取得
    const style = window.getComputedStyle(modalClone);
    // max-heightの値を取得
    const modalMaxHeigth = parseFloat(style.getPropertyValue('max-height'));
    // クローンを削除
    document.body.removeChild(modalClone);
    // scrollableの一番下の位置を取得
    const scrollableBottom = scrollable.scrollHeight;
    let isBottom = false;
    if (top + modalMaxHeigth > scrollableBottom) {
        isBottom = true;
        top = range.top + scrollable.scrollTop;
    }
    if (isBottom) {
        modal.style.bottom = `${scrollableBottom - top + 30}px`;
    }
    else {
        modal.style.top = `${top}px`;
    }
};
/**
 *
 * @param targetElementId
 *  指定した要素のテキストをクリップボードにコピーする
 * テキストが空の場合、アラートを表示する
 */
export const copyToClipboard = (targetElementId) => {
    const element = document.getElementById(targetElementId);
    if (!element)
        throw new Error('Element not found');
    // innerTextはdiv+<br>の組み合わせで改行数が二重にカウントされることがあるため、
    // 1 div = 1行として厳密に変換するconvertEditableDomToTextを使用する
    // (プレビュー・書き出し機能と同様、末尾のレイアウト維持用の空行のみを除去する)
    const code = removeEmptyLinesAtEnd(convertEditableDomToText(element));
    if (code !== '') {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        alert('コードがクリップボードにコピーされました。');
    }
    else {
        alert('コピーするコードがありません。');
    }
};
export const cleartInputText = (inputAreaId, initeText) => {
    const text = document.getElementById(inputAreaId);
    if (!text)
        return;
    if (!confirm('テキストをクリアしますか？'))
        return;
    for (let i = 0; i < 40; i++) {
        initeText += '<div></div>';
    }
    text.innerHTML = initeText;
};
export function generateHtmlFromDiff(beforeText, afterText) {
    const dmp = new DiffMatchPatch();
    const diff = dmp.diff_main(beforeText, afterText);
    dmp.diff_cleanupSemantic(diff);
    let beforeHtml = "";
    let afterHtml = "";
    diff.forEach(([operation, text]) => {
        switch (operation) {
            case -1: // 削除されたテキスト
                beforeHtml += `<span style="text-decoration: line-through;background:#ffb3b3;">${text}</span>`;
                break;
            case 1: // 追加されたテキスト
                afterHtml += `<span style="background-color: yellow;">${text}</span>`;
                break;
            default: // 変更されていないテキスト
                beforeHtml += text;
                afterHtml += text;
                break;
        }
    });
    return {
        beforeHtml: beforeHtml,
        afterHtml: afterHtml,
        diff: diff,
    };
}
export function convertSpaceEntity(text) {
    if (text === " ") {
        return "&nbsp;";
    }
    if (text === "　") {
        return "&#x3000;";
    }
    return text;
}
/**
 * @param inputAreaId
 * 最後の行から8行目移行のいずれかが空でない場合、新しい行を追加する
 * 生成ページでは、モーダル表示を行う為、高さが必要なので、常に一定数の行を下に追加する
 */
export function addNewLines(inputAreaId) {
    const textArea = document.getElementById(inputAreaId);
    if (!textArea)
        return;
    const divElements = textArea.getElementsByTagName('div');
    if (!divElements)
        return;
    let appendDiv = false;
    for (let i = divElements.length - 1; i >= divElements.length - 8 && i > 0; i--) {
        if (divElements[i].innerText.trim() !== '') {
            appendDiv = true;
            break;
        }
    }
    if (appendDiv || divElements.length < 10) {
        for (let i = 0; i < 40; i++) {
            const newDiv = document.createElement('div');
            textArea.appendChild(newDiv);
        }
    }
}
export const newLineExpr = new RegExp('(?<=[。\.])');
export function multiLineCount(text) {
    return text.split(/\r\n|\r|\n/).length;
}
export function removeNewLine(text) {
    return text.replace(/\r\n|\r|\n/g, '');
}
/**
 * 文章を改行で分割し、各行をdiv要素で囲む（生成結果の改行構造をそのまま維持するため）
 * @param text 入力文章
 * @returns 整形された文章
 */
export function formatText(text) {
    const lines = text.split(/\r\n|\r|\n/);
    const formatted = lines.map((line, index, array) => {
        if (index === 0 && line === '')
            return;
        const content = line.replace(/<\/?div>/g, '');
        // 空行はブラウザのinnerText/コピー時に改行として認識されるよう<br>を明示的に入れる
        return '<div>' + (content === '' ? '<br>' : content) + '</div>';
    }).join('');
    return formatted;
}
/**
 * 文章を句点とピリオドで分割した配列を返す
 * @param text 入力文章
 * @returns 分割された文章の配列
 */
export function formatTextArray(text) {
    const sentences = text.split(newLineExpr);
    return sentences.map((sentence, index, array) => {
        if (index === 0 && sentence === '')
            return '';
        return sentence.replace(/<\/?div>/g, '');
    });
}
/**
 * テキストエリアに入力された文章を読み上げる
 * ChatGPTのAPIを使用して音声ファイルを生成し、再生する
 * @param textArea テキストエリア
 * @param startSpeechBtn 音声再生ボタン
 * @param stopSpeechBtn 音声停止ボタン
 * @param maxTextLength 最大文字数
 * @param apiBaseUrl APIのベースURL
 * @param userId ユーザーID
 * @param clientId クライアントID
 * @param speechPending 音声生成中かどうかのフラグ
 * @param currentAudioIndex 現在再生中の音声ファイルのインデックス
 * @param isStopped 音声再生が停止されたかどうかのフラグ
 * @param currentAudio 現在再生中の音声ファイル
 * @returns 生成された音声
 */
export const generateSpeech = async (textArea, startSpeechBtn, stopSpeechBtn, maxTextLength, apiBaseUrl, userId, clientId, speechPending, currentAudioIndex, isStopped, currentAudio) => {
    if (!textArea || !startSpeechBtn || !stopSpeechBtn)
        return;
    const placeholder = textArea.getElementsByClassName('placeholder')[0];
    let text = textArea.innerText;
    if (placeholder)
        text = text.replace(placeholder.innerText, '');
    if (text.length > maxTextLength) {
        alert('文字数が上限を超えています');
        return;
    }
    else if (text.length === 0) {
        alert('読み上げ文章が入力されていません');
        return;
    }
    try {
        speechPending.value = true;
        const response = await axios.post(`${apiBaseUrl}/gpt/speech`, {
            clientId: clientId,
            userId: userId,
            text: text
        });
        speechPending.value = false;
        const speechFiles = response.data.speechFiles;
        console.log('ResponseAudioList:', speechFiles);
        currentAudioIndex = 0;
        isStopped = false;
        const playNextAudio = async () => {
            // 再生中の音声を停止するか、音声が最後まで再生された場合
            if (currentAudioIndex >= speechFiles.length || isStopped) {
                startSpeechBtn.style.display = 'flex';
                stopSpeechBtn.style.display = 'none';
                // 音声再生用のユーザーディレクトリを削除
                try {
                    await axios.delete(`${apiBaseUrl}/gpt/speech/${userId}`);
                    console.log('SpeechDirectory deleted successfully');
                }
                catch (error) {
                    console.error('Error :', error);
                }
                return;
            }
            currentAudio = new Audio(speechFiles[currentAudioIndex]);
            currentAudio.play();
            currentAudio.addEventListener('ended', () => {
                currentAudioIndex++;
                playNextAudio();
            });
        };
        playNextAudio();
        startSpeechBtn.style.display = 'none';
        stopSpeechBtn.style.display = 'flex';
        stopSpeechBtn.addEventListener('click', async () => {
            if (currentAudio) {
                currentAudio.pause();
                currentAudio.currentTime = 0; // 再生位置を先頭に戻す
            }
            isStopped = true;
            startSpeechBtn.style.display = 'flex';
            stopSpeechBtn.style.display = 'none';
            try {
                await axios.delete(`${apiBaseUrl}/gpt/speech/${userId}`);
                console.log('SpeechDirectory deleted successfully');
            }
            catch (error) {
                console.error('Error deleting SpeechDirectory:', error);
            }
        });
    }
    catch (error) {
        speechPending.value = false;
        console.error('Error generating speech:', error);
        alert('音声生成に失敗しました');
    }
};
export const convertEditableDomToText = (textArea) => {
    const textLines = [];
    let currentLineText = '';
    const commitCurrentLine = () => {
        textLines.push(currentLineText);
        currentLineText = '';
    };
    const readNode = (node) => {
        // テキスト
        if (node.nodeType === Node.TEXT_NODE) {
            currentLineText += node.textContent ?? '';
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }
        const el = node;
        // placeholderは無視
        if (el.classList?.contains('placeholder')) {
            return;
        }
        const tag = el.tagName.toLowerCase();
        // br は改行
        if (tag === 'br') {
            commitCurrentLine();
            return;
        }
        // div は1行コンテナとして扱う
        if (tag === 'div') {
            // 空div または <div><br></div> は空行
            if (el.childNodes.length === 0 ||
                (el.childNodes.length === 1 &&
                    el.firstChild?.nodeType === Node.ELEMENT_NODE &&
                    el.firstChild.tagName.toLowerCase() === 'br')) {
                commitCurrentLine();
                return;
            }
            // div内の子を処理
            el.childNodes.forEach((child) => readNode(child));
            commitCurrentLine();
            return;
        }
        // span / p / その他は中身だけ処理
        el.childNodes.forEach((child) => readNode(child));
    };
    textArea.childNodes.forEach((node) => readNode(node));
    if (currentLineText !== '') {
        textLines.push(currentLineText);
    }
    return textLines
        .map((line) => line
        .replace(/ /g, '\u00A0')
        .replace(/　/g, '\u3000'))
        .join('\n');
};
/**
 * @param textAreaId
 * テキストエリアをCtrl+A等で全選択してコピーした際に、
 * レイアウト維持用に末尾へ追加している余白行までクリップボードに含まれてしまうのを防ぐ。
 * 全選択（範囲がテキストエリア全体）を検知した場合のみ、余白行を除いた本来のテキストに差し替える。
 */
export const setupFullSelectionCopyFix = (textAreaId) => {
    const textArea = document.getElementById(textAreaId);
    if (!textArea)
        return;
    textArea.addEventListener('copy', (event) => {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0)
            return;
        const range = selection.getRangeAt(0);
        // 末尾の余白行は中身が空のdivのため、ブラウザはその終端位置を
        // 「テキストエリア全体の後ろ」ではなく「その空divの内部」として表現することがあり、
        // Rangeの境界点同士の比較では正しく全選択と判定できない。
        // そこで選択範囲の文字数が全文の文字数と一致するかで判定する
        // （連続する部分文字列の長さが全体の長さと一致するのは、全選択のときだけ）
        const totalLength = (textArea.textContent ?? '').length;
        const isFullySelected = totalLength > 0 && range.toString().length === totalLength;
        if (!isFullySelected)
            return;
        event.preventDefault();
        event.clipboardData?.setData('text/plain', removeEmptyLinesAtEnd(convertEditableDomToText(textArea)));
    });
};
// 改行コードを統一する
export const normalizeLineBreaks = (text) => {
    return text
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');
};
// テキストの正規化と文字数カウントの関数
export const normalizeTextForCount = (text) => {
    return normalizeLineBreaks(text)
        // 空白類・改行・タブ・nbsp・ゼロ幅文字を除去
        .replace(/[\n\t \u00A0\u200B\u200C\uFEFF]/g, '')
        .replace(/　/g, '');
};
// 校正前のテキストの文字数をカウントする関数
export const countProofreadTextLength = (text) => {
    const normalizedText = normalizeTextForCount(text);
    // Intl.Segmenterを使って、サロゲートペアや結合文字を「1文字」としてカウントする
    const segmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' });
    const segments = Array.from(segmenter.segment(normalizedText));
    return segments.length;
};
// プレビュー時のスペースと改行を保持するためのテキストの正規化関数
export const normalizeTextForDiff = (text) => {
    return normalizeLineBreaks(text).replace(/\u00A0/g, ' ');
};
// 校正・自動修正へ送るテキストの正規化関数
// 入力エリアのテキストは連続する半角スペースを保持するためNBSPへ変換しているが、
// 辞書のpatternは半角スペースのまま正規表現化されるため、送信前に戻さないと
// スペースを含む語句が一致しない。NBSPと半角スペースは1文字対1文字のため、
// textlintが返すindexは変換前のテキストにもそのまま使える。
export const normalizeSpaceForLint = (text) => {
    return text.replace(/\u00A0/g, ' ');
};
// プレビュー（自動修正, エクスポート）時の末尾の空行を削除する関数
export const removeEmptyLinesAtEnd = (text) => {
    return normalizeLineBreaks(text).replace(/(?:\n[ \t\u00A0\u3000]*)+$/g, '');
};
